import apiEndpoints from '@/services/apiEndpoints';
import http from '@/services/http';

export default {
  state: () => {},
  mutations: {},
  getters: {},
  actions: {
    async getListVendor (_, payload) {
      const vendorResponse = await http.get(apiEndpoints.getListVendor, payload);
      if (vendorResponse.status && vendorResponse.data) return vendorResponse.data;
      return [];
    },
    async deleteVendor (_, payload) {
      return await http.delete(apiEndpoints.deleteVendor.replace('{id}', payload.id), {});
    },
    async exportVendor (_, payload) {
      const vendorResponse = await http.downloadPost(apiEndpoints.exportVendor, payload);
      if (vendorResponse.status) return vendorResponse;
      return false;
    },
    async createVendor (_, payload) {
      return await http.post(apiEndpoints.createVendor, payload);
    },
    async getVendorById (_, idVendor) {
      const vendorResponse = await http.get(apiEndpoints.getVendor.replace('{id}', idVendor), {});
      if (vendorResponse.status && vendorResponse.data) return vendorResponse.data;
      return false;
    },
    async updateVendor (_, payload) {
      const id = payload.id;
      delete payload.id;
      return await http.put(apiEndpoints.updateVendor.replace('{id}', id), payload);
    },
    async searchVendor (_, payload) {
      const defaultPayload = {
        page: 1,
        per_page: 1000,
        order_column: 'id',
        order_direction: 'desc',
      };
      payload = Object.assign(defaultPayload, payload);
      return await http.get(apiEndpoints.getListVendor, payload);
    },
    async updateStatus (_, payload) {
      return await http.post(apiEndpoints.vendorUpdateStatus, payload);
    },
  },
};
